import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=751d19a4&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=751d19a4&lang=scss&scoped=true&"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=751d19a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d19a4",
  null
  
)

export default component.exports